import { IpaginatedToppagespress, IToppagespressItem } from '../models'

export enum ToppagespressActionTypes {
  SEARCH_TOPPAGESPRESS = 'toppagespress/search',
  SEARCHING_TOPPAGESPRESS = 'toppagespress/searching',
  FOUND_TOPPAGESPRESS = 'toppagespress/found',
  SEARCHING_TOPPAGESPRESS_FAILED = 'toppagespress/searching_failed',

  LOAD_TOPPAGESPRESS = 'toppagespress/load',
  LOADING_TOPPAGESPRESS = 'toppagespress/loading',
  LOADED_TOPPAGESPRESS = 'toppagespress/loaded',
  LOADING_TOPPAGESPRESS_FAILED = 'toppagespress/loading_failed',

  ADD_TOPPAGESPRESS = 'toppagespress/add',
  ADDING_TOPPAGESPRESS = 'toppagespress/adding',
  ADDED_TOPPAGESPRESS = 'toppagespress/added',
  ADDING_TOPPAGESPRESS_FAILED = 'toppagespress/adding_failed',

  REMOVE_TOPPAGEPRESS = 'toppagespress/remove',
  REMOVING_TOPPAGEPRESS = 'toppagespress/removing',
  REMOVED_TOPPAGEPRESS = 'toppagespress/removed',
  REMOVING_TOPPAGEPRESS_FAILED = 'toppagespress/removing_failed',

  SOFT_REMOVE_TOPPAGESPRESS = 'toppagespress/soft_remove',
  SOFT_REMOVING_TOPPAGESPRESS = 'toppagespress/soft_removing',
  SOFT_REMOVED_TOPPAGESPRESS = 'toppagespress/soft_removed',
  SOFT_REMOVING_TOPPAGESPRESS_FAILED = 'toppagespress/soft_removing_failed',

  EDIT_TOPPAGESPRESS = 'toppagespress/edit',
  EDITING_TOPPAGESPRESS = 'toppagespress/editing',
  EDITED_TOPPAGESPRESS = 'toppagespress/edited',
  EDITING_TOPPAGESPRESS_FAILED = 'toppagespress/editing_failed',

  VIEW_TOPPAGESPRESS = 'toppagespress/view',
  VIEWING_TOPPAGESPRESS = 'toppagespress/viewing',
  VIEWED_TOPPAGESPRESS = 'toppagespress/viewed',
  VIEWING_TOPPAGESPRESS_FAILED = 'toppagespress/viewing_failed',
}

export function searchToppagespress(searchOptions: TSearchOptions | string, keep?: boolean): ISearchToppagespressAction {
  return {
    type: ToppagespressActionTypes.SEARCH_TOPPAGESPRESS,
    searchOptions: typeof searchOptions === 'string' ? { searchString: searchOptions } : searchOptions,
    keep: keep,
  }
}

export function searchingToppagespress(): ISearchingToppagespressAction {
  return {
    type: ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS,
  }
}

export function foundToppagespress(toppagespress: IpaginatedToppagespress, keep?: boolean): IFoundToppagespressAction {
  return {
    type: ToppagespressActionTypes.FOUND_TOPPAGESPRESS,
    keep: keep,
    payload: {
      toppagespress,
    },
  }
}

export function searchingToppagespressFailed(): ISearchingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS_FAILED,
  }
}

export function loadToppagespress(loadOptions: TSearchOptions): ILoadToppagespressAction {
  return {
    type: ToppagespressActionTypes.LOAD_TOPPAGESPRESS,
    loadOptions: loadOptions,
  }
}

export function loadingToppagespress(): ILoadingToppagespressAction {
  return {
    type: ToppagespressActionTypes.LOADING_TOPPAGESPRESS,
  }
}

export function loadedToppagespress(toppagespress: IpaginatedToppagespress): ILoadedToppagespressAction {
  return {
    type: ToppagespressActionTypes.LOADED_TOPPAGESPRESS,
    payload: {
      toppagespress,
    },
  }
}

export function loadingToppagespressFailed(): ILoadingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.LOADING_TOPPAGESPRESS_FAILED,
  }
}

export function addToppagespress(toppagepress: IToppagespressItem): IAddToppagespressAction {
  return {
    type: ToppagespressActionTypes.ADD_TOPPAGESPRESS,
    payload: toppagepress,
  }
}

export function addingToppagespress(): IAddingToppagespressAction {
  return {
    type: ToppagespressActionTypes.ADDING_TOPPAGESPRESS,
  }
}

export function addedToppagespress(toppagespress: IpaginatedToppagespress): IAddedToppagespressAction {
  return {
    type: ToppagespressActionTypes.ADDED_TOPPAGESPRESS,
    payload: {
      toppagespress,
    },
  }
}

export function addingToppagespressFailed(errData: { data: { message: string; field?: string }; status: number }): IAddingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.ADDING_TOPPAGESPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function removeToppagepress(toppagepress: IToppagespressItem): IRemoveToppagepressAction {
  return {
    type: ToppagespressActionTypes.REMOVE_TOPPAGEPRESS,
    payload: toppagepress,
  }
}

export function removingToppagepress(): IRemovingToppagepressAction {
  return {
    type: ToppagespressActionTypes.REMOVING_TOPPAGEPRESS,
  }
}

export function removedToppagepress(): IRemovedToppagepressAction {
  return {
    type: ToppagespressActionTypes.REMOVED_TOPPAGEPRESS,
  }
}

export function removingToppagepressFailed(): IRemovingToppagepressFailedAction {
  return {
    type: ToppagespressActionTypes.REMOVING_TOPPAGEPRESS_FAILED,
  }
}

export function softRemoveToppagespress(toppagepress: IToppagespressItem): ISoftRemoveToppagespressAction {
  return {
    type: ToppagespressActionTypes.SOFT_REMOVE_TOPPAGESPRESS,
    payload: toppagepress,
  }
}

export function softRemovingToppagespress(): ISoftRemovingToppagespressAction {
  return {
    type: ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS,
  }
}

export function softRemovedToppagespress(toppagepress: IToppagespressItem): ISoftRemovedToppagespressAction {
  return {
    type: ToppagespressActionTypes.SOFT_REMOVED_TOPPAGESPRESS,
    payload: toppagepress,
  }
}

export function softRemovingToppagespressFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): ISoftRemovingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function editToppagespress(toppagepress: IToppagespressItem): IEditToppagespressAction {
  return {
    type: ToppagespressActionTypes.EDIT_TOPPAGESPRESS,
    payload: toppagepress,
  }
}

export function editingToppagespress(): IEditingToppagespressAction {
  return {
    type: ToppagespressActionTypes.EDITING_TOPPAGESPRESS,
  }
}

export function editedToppagespress(toppagespress: IToppagespressItem): IEditedToppagespressAction {
  return {
    type: ToppagespressActionTypes.EDITED_TOPPAGESPRESS,
    payload: toppagespress,
  }
}

export function editingToppagespressFailed(errData: {
  data: { message: string; field?: string }
  status: number
}): IEditingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.EDITING_TOPPAGESPRESS_FAILED,
    message: errData.data.message,
    status: errData.status,
    field: errData.data.field,
  }
}

export function viewToppagespress(toppagepress: IToppagespressItem): IViewToppagespressAction {
  return {
    type: ToppagespressActionTypes.VIEW_TOPPAGESPRESS,
    payload: toppagepress,
  }
}

export function viewingToppagespress(): IViewingToppagespressAction {
  return {
    type: ToppagespressActionTypes.VIEWING_TOPPAGESPRESS,
  }
}

export function viewedToppagespress(toppagespress: IToppagespressItem): IViewedToppagespressAction {
  return {
    type: ToppagespressActionTypes.VIEWED_TOPPAGESPRESS,
    payload: toppagespress,
  }
}

export function viewingToppagespressFailed(): IViewingToppagespressFailedAction {
  return {
    type: ToppagespressActionTypes.VIEWING_TOPPAGESPRESS_FAILED,
  }
}

type TSearchOptions = {
  searchString?: string
  searchField?: string
  page?: number
  limit?: number
  populate?: boolean
  sort?: {
    field: string
    method?: 'asc' | 'desc'
  }
  filters?: { field: string; value: string }[]
}

export interface ISearchToppagespressAction {
  type: ToppagespressActionTypes.SEARCH_TOPPAGESPRESS
  searchOptions: TSearchOptions
  keep?: boolean
}

export interface ISearchingToppagespressAction {
  type: ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS
}

export interface IFoundToppagespressAction {
  type: ToppagespressActionTypes.FOUND_TOPPAGESPRESS
  keep?: boolean
  payload: {
    toppagespress: IpaginatedToppagespress
  }
}

export interface ISearchingToppagespressFailedAction {
  type: ToppagespressActionTypes.SEARCHING_TOPPAGESPRESS_FAILED
}

export interface ILoadToppagespressAction {
  type: ToppagespressActionTypes.LOAD_TOPPAGESPRESS
  loadOptions: TSearchOptions
}

export interface ILoadingToppagespressAction {
  type: ToppagespressActionTypes.LOADING_TOPPAGESPRESS
}

export interface ILoadedToppagespressAction {
  type: ToppagespressActionTypes.LOADED_TOPPAGESPRESS
  payload: {
    toppagespress: IpaginatedToppagespress
  }
}

export interface ILoadingToppagespressFailedAction {
  type: ToppagespressActionTypes.LOADING_TOPPAGESPRESS_FAILED
}

export interface IAddToppagespressAction {
  type: ToppagespressActionTypes.ADD_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface IAddingToppagespressAction {
  type: ToppagespressActionTypes.ADDING_TOPPAGESPRESS
}

export interface IAddedToppagespressAction {
  type: ToppagespressActionTypes.ADDED_TOPPAGESPRESS
  payload: {
    toppagespress: IpaginatedToppagespress
  }
}

export interface IAddingToppagespressFailedAction {
  type: ToppagespressActionTypes.ADDING_TOPPAGESPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IRemoveToppagepressAction {
  type: ToppagespressActionTypes.REMOVE_TOPPAGEPRESS
  payload: IToppagespressItem
}

export interface IRemovingToppagepressAction {
  type: ToppagespressActionTypes.REMOVING_TOPPAGEPRESS
}

export interface IRemovedToppagepressAction {
  type: ToppagespressActionTypes.REMOVED_TOPPAGEPRESS
}

export interface IRemovingToppagepressFailedAction {
  type: ToppagespressActionTypes.REMOVING_TOPPAGEPRESS_FAILED
}

export interface ISoftRemoveToppagespressAction {
  type: ToppagespressActionTypes.SOFT_REMOVE_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface ISoftRemovingToppagespressAction {
  type: ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS
}

export interface ISoftRemovedToppagespressAction {
  type: ToppagespressActionTypes.SOFT_REMOVED_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface ISoftRemovingToppagespressFailedAction {
  type: ToppagespressActionTypes.SOFT_REMOVING_TOPPAGESPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IEditToppagespressAction {
  type: ToppagespressActionTypes.EDIT_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface IEditingToppagespressAction {
  type: ToppagespressActionTypes.EDITING_TOPPAGESPRESS
}

export interface IEditedToppagespressAction {
  type: ToppagespressActionTypes.EDITED_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface IEditingToppagespressFailedAction {
  type: ToppagespressActionTypes.EDITING_TOPPAGESPRESS_FAILED
  message: string
  status: number
  field?: string
}

export interface IViewToppagespressAction {
  type: ToppagespressActionTypes.VIEW_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface IViewingToppagespressAction {
  type: ToppagespressActionTypes.VIEWING_TOPPAGESPRESS
}

export interface IViewedToppagespressAction {
  type: ToppagespressActionTypes.VIEWED_TOPPAGESPRESS
  payload: IToppagespressItem
}

export interface IViewingToppagespressFailedAction {
  type: ToppagespressActionTypes.VIEWING_TOPPAGESPRESS_FAILED
}

export type ToppagespressAction =
  | ISearchToppagespressAction
  | ISearchingToppagespressAction
  | IFoundToppagespressAction
  | ISearchingToppagespressFailedAction
  | ILoadToppagespressAction
  | ILoadingToppagespressAction
  | ILoadedToppagespressAction
  | ILoadingToppagespressFailedAction
  | IAddToppagespressAction
  | IAddingToppagespressAction
  | IAddedToppagespressAction
  | IAddingToppagespressFailedAction
  | IRemoveToppagepressAction
  | IRemovingToppagepressAction
  | IRemovedToppagepressAction
  | IRemovingToppagepressFailedAction
  | ISoftRemoveToppagespressAction
  | ISoftRemovingToppagespressAction
  | ISoftRemovedToppagespressAction
  | ISoftRemovingToppagespressFailedAction
  | IEditToppagespressAction
  | IEditingToppagespressAction
  | IEditedToppagespressAction
  | IEditingToppagespressFailedAction
  | IViewToppagespressAction
  | IViewingToppagespressAction
  | IViewedToppagespressAction
  | IViewingToppagespressFailedAction
